import { ConnectionState, Client as RealTwilioClient } from '@twilio/conversations'

import { TwilioConversationsMock } from '@lyrahealth-inc/shared-app-logic'

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace Cypress {
    interface Chainable {
      spyOnTwilioConversationsCreate: () => void
      expectTwilioConversationsCalledOnceWith: (accessToken: string) => void
      twilioMessageAdded: (message: any) => void
    }
  }
  interface TwilioEvents {
    messageAdded: Array<() => void>
    conversationAdded: Array<() => void>
    typingStarted: Array<() => void>
    typingEnded: Array<() => void>
  }
  interface Window {
    Cypress: any
    conversationsClientMock: any
  }
}

const conversationsClientMock = new TwilioConversationsMock()

if (window.Cypress) {
  window.conversationsClientMock = conversationsClientMock
}

// Export the Client that switches between real and mock based on Cypress environment
export const Client = (messageAccessToken: string) => {
  if (window.Cypress) {
    conversationsClientMock.mockCreated(messageAccessToken)
    return conversationsClientMock
  } else {
    return new RealTwilioClient(messageAccessToken)
  }
}

// Re-export ConnectionState directly from @twilio/conversations
export type { ConnectionState }

export const TwilioConversations = window.Cypress ? conversationsClientMock : RealTwilioClient
